import React, { createContext, useState } from 'react';

const CheckPopUpContext = createContext();

const CheckPopUp = ({ children }) => {
  const [opcionSeleccionadaPopUp1, setOpcionSeleccionadaPopUp1] = useState(null);
  const [opcionSeleccionadaPopUp2, setOpcionSeleccionadaPopUp2] = useState(null);
  const [tipoConductaSICOF, setTipoConductaSICOF] = useState(null);

  return (
    <CheckPopUpContext.Provider value={{ opcionSeleccionadaPopUp1, setOpcionSeleccionadaPopUp1, opcionSeleccionadaPopUp2, setOpcionSeleccionadaPopUp2,
      tipoConductaSICOF, setTipoConductaSICOF}}>
      {children}
    </CheckPopUpContext.Provider>
  );
};

export { CheckPopUp, CheckPopUpContext };